import {
    WALLET_SUCCESSFUL_GET,
    WALLET_UPDATE_FILTERTRANSACTIONTYPE,
    WALLET_UPDATE_FILTERACCOUNTTRANSTYPE,
    WALLET_UPDATE_FILTERSTARTDATE,
    WALLET_UPDATE_FILTERENDDATE,
    WALLET_SUCCESSFUL_BALANCE_AMOUNT
} from 'reducers/constants';

const initialState = {
    data: null,
    filterTransactionType: null,
    filterAccountTransType: null,
    filterStartDate: "",
    filterEndDate: "",
    balance: null
}

export default function (state = initialState, action) {
    switch (action.type) {

        case WALLET_SUCCESSFUL_GET:
            return {
                ...state,
                data: Object.assign({}, action.payload)
            }

        case WALLET_UPDATE_FILTERTRANSACTIONTYPE:
            return {
                ...state,
                filterTransactionType: action.payload != null ? action.payload : null
            }

        case WALLET_UPDATE_FILTERACCOUNTTRANSTYPE:
            return {
                ...state,
                filterAccountTransType: action.payload != null ? action.payload : null
            }

        case WALLET_UPDATE_FILTERSTARTDATE:
            return {
                ...state,
                filterStartDate: action.payload != "" ? action.payload : ""
            }

        case WALLET_UPDATE_FILTERENDDATE:
            return {
                ...state,
                filterEndDate: action.payload != null ? action.payload : ""
            }

        case WALLET_SUCCESSFUL_BALANCE_AMOUNT:
            return {
                ...state,
                balance: Object.assign({}, action.payload)
            }

        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./src/reducers/wallet/walletReducer.js